import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * WordPress dependencies
 */
import { useEffect, useState } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
/** @typedef {import('@wordpress/element').RefObject} RefObject */

/**
 * Returns true when the block is hovered and in navigation or outline mode, false if not.
 *
 * @param {RefObject} ref React ref with the block element.
 *
 * @return {boolean} Hovered state.
 */

export function useIsHovered(ref) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setHovered = _useState2[1];

  var _useSelect = useSelect(function (select) {
    var _select = select('core/block-editor'),
        selectIsNavigationMode = _select.isNavigationMode,
        getSettings = _select.getSettings;

    return {
      isNavigationMode: selectIsNavigationMode(),
      isOutlineMode: getSettings().outlineMode
    };
  }, []),
      isNavigationMode = _useSelect.isNavigationMode,
      isOutlineMode = _useSelect.isOutlineMode;

  useEffect(function () {
    function addListener(eventType, value) {
      function listener(event) {
        if (event.defaultPrevented) {
          return;
        }

        event.preventDefault();
        setHovered(value);
      }

      ref.current.addEventListener(eventType, listener);
      return function () {
        ref.current.removeEventListener(eventType, listener);
      };
    }

    if (isHovered) {
      return addListener('mouseout', false);
    }

    if (isOutlineMode || isNavigationMode) {
      return addListener('mouseover', true);
    }
  }, [isNavigationMode, isOutlineMode, isHovered, setHovered]);
  return isHovered;
}
//# sourceMappingURL=use-is-hovered.js.map